<template>
    <div v-bind:id="internalId">
        <div v-if="altLabel">
            <pc-label v-bind="labelBinder" />
        </div>
        <fieldset>
            <legend class="visually-hidden">
                {{ label || altLabel }}
            </legend>
            <div class="container px-0">
                <div
                    class="btn-group btn-group-toggle w-100"
                    v-bind:class="getReadOnlyClass"
                    data-bs-toggle="buttons">
                    <label
                        v-for="(option, index) in options"
                        v-bind:key="index"
                        v-bind:data-test-value="option[valueProp]"
                        v-bind:data-test-label="option[textProp]"
                        class="btn"
                        v-bind:class="getTileClass(String(option[valueProp]))">
                        <input
                            v-bind:id="optionIds[index]"
                            v-model="internalValue"
                            v-bind:disabled="disabled || readonly"
                            v-bind:value="option[valueProp]"
                            v-bind:name="nameOverride"
                            v-bind:class="inputClasses"
                            type="radio"
                            class="btn-group-input"
                            v-on="listeners" />
                        {{ option[textProp] }}
                    </label>
                </div>
            </div>
        </fieldset>
        <div
            v-if="showValidationErrors && validationError"
            class="invalid-feedback d-block fw-bold">
            {{ validationError }}
        </div>
    </div>
</template>

<script>
    import base from "./_inputBase.vue";
    export default {
        extends: base,
        props: {
            options: { type: Array, required: true },
            valueProp: { type: String, required: false, default: "value" },
            textProp: { type: String, required: false, default: "text" },
            outline: { type: Boolean, required: false, default: false }
        },
        computed: {
            optionIds() {
                return this.options.map((o) => `${this.internalId}_${o[this.valueProp]}`);
            },
            nameOverride() {
                return `${this.internalName}_${this.internalId}`;
            },
            getReadOnlyClass() {
                return {
                    "display-only": this.readonly == true || this.disabled == true
                };
            }
        },
        methods: {
            getTileClass(optionValue) {
                return {
                    active: optionValue === this.internalValue,
                    "btn-secondary": !this.outline,
                    "btn-outline-primary": this.outline
                };
            }
        }
    };
</script>

<style lang="scss" scoped>
    // For read-only view
    .display-only {
        opacity: 0.6;
        pointer-events: none;
        cursor: not-allowed;
    }

    // To not display the input radio buttons
    .btn-group-input {
        display: none;
    }
</style>
